const strictSelection = [{
    path: "/strictSelectionIndex",
    name: "strictSelectionIndex",
    component: () =>
        import ("@/views/strictSelection/strictSelectionIndex.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/strictSelectionBuyHouse",
    name: "strictSelectionBuyHouse",
    component: () =>
        import ("@/views/strictSelection/strictSelectionBuyHouse.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/strictSelectionSellHouse",
    name: "strictSelectionSellHouse",
    component: () =>
        import ("@/views/strictSelection/strictSelectionSellHouse.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/page_j",
    name: "page_j",
    component: () =>
        import ("@/views/strictSelection/page_j.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/page_l",
    name: "page_l",
    component: () =>
        import ("@/views/strictSelection/page_l.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/strictSelectionCompanyList",
    name: "strictSelectionCompanyList",
    component: () =>
        import ("@/views/strictSelection/strictSelectionCompanyList.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/strictSelectionItemList",
    name: "strictSelectionItemList",
    component: () =>
        import ("@/views/strictSelection/strictSelectionItemList.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/strictSelectionHouseList",
    name: "strictSelectionHouseList",
    component: () =>
        import ("@/views/strictSelection/strictSelectionHouseList.vue"),
    meta: {
        title: "卖旧换新",
    }
}, {
    path: "/strictSelectionItemDetail",
    name: "strictSelectionItemDetail",
    component: () =>
        import ("@/views/strictSelection/strictSelectionItemDetail.vue"),
    meta: {
        title: "卖旧换新",
    }
}];
export default strictSelection;